import React, { useEffect, useRef } from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import { Loader } from '@/components/Loader/loader';
import { AUTH0_LOGIN_ERROR_KEY } from '@/constants/auth0';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import useAuth0Login, { trackLoginResult } from '@/hooks/useAuth0Login';
import { log } from '@/utils/functions/logger/logger';

// Retour d'Universal Login (identifiant, mot de passe et MFA validés par Auth0) : échange du token Auth0
// contre la session de l'Espace Client, puis même suite que l'ancien login (profil, dashboard).
const Auth0Callback: React.FC = () => {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const { completeLogin } = useAuth0Login();
  const { login } = useAuth();
  const navigate = useNavigate();
  // StrictMode rejoue les effets : l'échange ne doit partir qu'une fois
  const startedRef = useRef(false);

  useEffect(() => {
    if (isLoading || startedRef.current) return;
    startedRef.current = true;

    const fail = (reason: string) => {
      log.error(`Auth0Callback: ${reason}`);
      trackLoginResult('KO');
      sessionStorage.setItem(AUTH0_LOGIN_ERROR_KEY, 'true');
      navigate(ROUTE.LOGIN, { replace: true });
    };

    if (error || !isAuthenticated) {
      fail(error ? error.message : 'not authenticated');

      return;
    }

    completeLogin()
      .then((profileData) => {
        trackLoginResult('OK');
        sessionStorage.setItem('islogin', 'true');
        navigate(ROUTE.DASHBOARD, { replace: true });
        login(profileData);
      })
      .catch((exchangeError: unknown) => fail(String(exchangeError)));
  }, [isLoading, isAuthenticated, error, completeLogin, login, navigate]);

  return <Loader />;
};

export default Auth0Callback;
